export default __webpack_public_path__ + "static/media/caret-down-light.cc766446.svg";